export default __webpack_public_path__ + "static/media/background-card-reports.adb5ab96.png";